module.exports = __webpack_public_path__ + "img/game_timesort.60a4cf32.webp";